"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userReducer = void 0;
var getUser_1 = require("./actions/getUser");
var putUser_1 = require("./actions/putUser");
var getUserFormStats_1 = require("./actions/getUserFormStats");
var __1 = require("..");
var initialState = {
    data: null,
};
var userReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case getUser_1.GET_USER.SUCCESS:
            return __assign(__assign({}, state), { data: action.response });
        case putUser_1.PUT_USER.SUCCESS:
            return __assign(__assign({}, state), { data: action.response });
        case __1.LOGOUT.ACTION:
            return initialState;
        case getUserFormStats_1.GET_USER_FORM_STATS.SUCCESS:
            return __assign(__assign({}, state), { userFormStats: action.response });
        default:
            return state;
    }
};
exports.userReducer = userReducer;
//# sourceMappingURL=user.reducer.js.map